import Stat_Average from "./statistics_components/Stat_Average.jsx";
import Stat_Bar_Graphs from "./statistics_components/Stat_Bar_Graphs.jsx";
import Stat_Box_Plots from "./statistics_components/Stat_Box_Plots.jsx";
import Stat_Certificate from "./statistics_components/Stat_Certificate.jsx";
import Stat_Data_Types from "./statistics_components/Stat_Data_Types.jsx";
import Stat_Describing_Data from "./statistics_components/Stat_Describing_Data.jsx";
import Stat_Descriptive_Stat from "./statistics_components/Stat_Descriptive_Stat.jsx";
import Stat_Estimation from "./statistics_components/Stat_Estimation.jsx";
import Stat_Frequency_Tables from "./statistics_components/Stat_Frequency_Tables.jsx";
import Stat_Gathering_Data from "./statistics_components/Stat_Gathering_Data.jsx";
import Stat_Histograms from "./statistics_components/Stat_Histograms.jsx";
import Stat_HOME from "./statistics_components/Stat_HOME.jsx";
import Stat_Hyp_Testing from "./statistics_components/Stat_Hyp_Testing.jsx";
import Stat_Hyp_Testing_Mean from "./statistics_components/Stat_Hyp_Testing_Mean.jsx";
import Stat_Hyp_Testing_Mean_Left_Tailed from "./statistics_components/Stat_Hyp_Testing_Mean_Left_Tailed.jsx";
import Stat_Hyp_Testing_Mean_Two_Tailed from "./statistics_components/Stat_Hyp_Testing_Mean_Two_Tailed.jsx";
import Stat_Hyp_Testing_Proportion from "./statistics_components/Stat_Hyp_Testing_Proportion.jsx";
import Stat_Hyp_Testing_Proportion_Left_Tailed from "./statistics_components/Stat_Hyp_Testing_Proportion_Left_Tailed.jsx";
import Stat_Hyp_Testing_Proportion_Two_Tailed from "./statistics_components/Stat_Hyp_Testing_Proportion_Two_Tailed.jsx";
import Stat_Inference from "./statistics_components/Stat_Inference.jsx";
import Stat_Interquartile_Range from "./statistics_components/Stat_Interquartile_Range.jsx";
import Stat_Introduction from "./statistics_components/Stat_Introduction.jsx";
import Stat_Making_Conclusions from "./statistics_components/Stat_Making_Conclusions.jsx";
import Stat_Mean from "./statistics_components/Stat_Mean.jsx";
import Stat_Measurement_Levels from "./statistics_components/Stat_Measurement_Levels.jsx";
import Stat_Median from "./statistics_components/Stat_Median.jsx";
import Stat_Mode from "./statistics_components/Stat_Mode.jsx";
import Stat_Normal_Distrib from "./statistics_components/Stat_Normal_Distrib.jsx";
import Stat_Parameters_And_Stat from "./statistics_components/Stat_Parameters_And_Stat.jsx";
import Stat_Pie_Charts from "./statistics_components/Stat_Pie_Charts.jsx";
import Stat_Populations_And_Samples from "./statistics_components/Stat_Populations_And_Samples.jsx";
import Stat_Population_Mean_Estimation from "./statistics_components/Stat_Population_Mean_Estimation.jsx";
import Stat_Population_Proportion_Estimation from "./statistics_components/Stat_Population_Proportion_Estimation.jsx";
import Stat_Prediction_And_Explanation from "./statistics_components/Stat_Prediction_And_Explanation.jsx";
import Stat_Quartiles_and_Percentiles from "./statistics_components/Stat_Quartiles_and_Percentiles.jsx";
import Stat_Range from "./statistics_components/Stat_Range.jsx";
import Stat_Sample_Types from "./statistics_components/Stat_Sample_Types.jsx";
import Stat_Standard_Deviation from "./statistics_components/Stat_Standard_Deviation.jsx";
import Stat_Standard_Normal_Distrib from "./statistics_components/Stat_Standard_Normal_Distrib.jsx";
import Stat_Students_T_Distrib from "./statistics_components/Stat_Students_T_Distrib.jsx";
import Stat_Study_Types from "./statistics_components/Stat_Study_Types.jsx";
import Stat_T_Table from "./statistics_components/Stat_T_Table.jsx";
import Stat_Variation from "./statistics_components/Stat_Variation.jsx";
import Stat_Z_Table from "./statistics_components/Stat_Z_Table.jsx";

const StatisticsComponentsMap = {
  "<Stat_Average />": Stat_Average,
  "<Stat_Bar_Graphs />": Stat_Bar_Graphs,
  "<Stat_Box_Plots />": Stat_Box_Plots,
  "<Stat_Certificate />": Stat_Certificate,
  "<Stat_Data_Types />": Stat_Data_Types,
  "<Stat_Describing_Data />": Stat_Describing_Data,
  "<Stat_Descriptive_Stat />": Stat_Descriptive_Stat,
  "<Stat_Estimation />": Stat_Estimation,
  "<Stat_Frequency_Tables />": Stat_Frequency_Tables,
  "<Stat_Gathering_Data />": Stat_Gathering_Data,
  "<Stat_Histograms />": Stat_Histograms,
  "<Stat_HOME />": Stat_HOME,
  "<Stat_Hyp_Testing />": Stat_Hyp_Testing,
  "<Stat_Hyp_Testing_Mean />": Stat_Hyp_Testing_Mean,
  "<Stat_Hyp_Testing_Mean_Left_Tailed />": Stat_Hyp_Testing_Mean_Left_Tailed,
  "<Stat_Hyp_Testing_Mean_Two_Tailed />": Stat_Hyp_Testing_Mean_Two_Tailed,
  "<Stat_Hyp_Testing_Proportion />": Stat_Hyp_Testing_Proportion,
  "<Stat_Hyp_Testing_Proportion_Left_Tailed />":
    Stat_Hyp_Testing_Proportion_Left_Tailed,
  "<Stat_Hyp_Testing_Proportion_Two_Tailed />":
    Stat_Hyp_Testing_Proportion_Two_Tailed,
  "<Stat_Inference />": Stat_Inference,
  "<Stat_Interquartile_Range />": Stat_Interquartile_Range,
  "<Stat_Introduction />": Stat_Introduction,
  "<Stat_Making_Conclusions />": Stat_Making_Conclusions,
  "<Stat_Mean />": Stat_Mean,
  "<Stat_Measurement_Levels />": Stat_Measurement_Levels,
  "<Stat_Median />": Stat_Median,
  "<Stat_Mode />": Stat_Mode,
  "<Stat_Normal_Distrib />": Stat_Normal_Distrib,
  "<Stat_Parameters_And_Stat />": Stat_Parameters_And_Stat,
  "<Stat_Pie_Charts />": Stat_Pie_Charts,
  "<Stat_Populations_And_Samples />": Stat_Populations_And_Samples,
  "<Stat_Population_Mean_Estimation />": Stat_Population_Mean_Estimation,
  "<Stat_Population_Proportion_Estimation />":
    Stat_Population_Proportion_Estimation,
  "<Stat_Prediction_And_Explanation />": Stat_Prediction_And_Explanation,
  "<Stat_Quartiles_and_Percentiles />": Stat_Quartiles_and_Percentiles,
  "<Stat_Range />": Stat_Range,
  "<Stat_Sample_Types />": Stat_Sample_Types,
  "<Stat_Standard_Deviation />": Stat_Standard_Deviation,
  "<Stat_Standard_Normal_Distrib />": Stat_Standard_Normal_Distrib,
  "<Stat_Students_T_Distrib />": Stat_Students_T_Distrib,
  "<Stat_Study_Types />": Stat_Study_Types,
  "<Stat_T_Table />": Stat_T_Table,
  "<Stat_Variation />": Stat_Variation,
  "<Stat_Z_Table />": Stat_Z_Table,
};

export default StatisticsComponentsMap;
